import React, { useState, useEffect } from "react";
import axios from "axios";
import {baseUrl} from "../comman/config";
import Select from "react-select";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { EventDateSessionFilter } from "../components/Filter/EventDateSessionFilter";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from 'xlsx';
import ModalContent from "../components/ModalContent";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { ItemNameStacked } from '../components/ItemName';
import {
  planningMath,
  applyPersonsQtyEdit,
  applyPlannedQtyEdit,
  rebuildFromRequiredQty,
  RecipePlanningTable,
} from "../components/RecipePlanningTable";


// "Recipe Feedback Report" is switched off until the report behind it is ready, the same as on
// Recipe Planning. Temporary, so nothing is removed: put this back to false and the button works.
const REPORT_BUTTONS_DISABLED = true;

// Process Steps and Feedback & Remarks are hidden on this screen at the client's request. The
// panels, their handlers and the four remarks rows in formData all stay -- the rows are still
// read and still saved, so nothing already written is lost while they are out of sight.
const SHOW_PROCESS_AND_REMARKS = false;

function RawMaterialReceipePlanning() {
  const today = new Date().toISOString().split("T")[0];
  const [mealList, setMealList] = useState([]);
  const [rmDetailForItem, setRMDetailForItem] = useState([]);
  const [maharajName, setMaharajName] = useState('');
  const [recipeStdRas, setRecipeStdRas] = useState(null);
  const [maharajDetail, setMaharajDetail] = useState('');
  const [itemDisable, setItemDisable] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [ingredientList, setIngredientList] = useState([]);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [session, setSession] = useState("");
  const [formData, setFormData] = useState([]);
  const [processStep, setProcessStep] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const [showMaharajModal, setShowMaharajModal] = useState(false);
  const [maharajList, setMaharajList] = useState([]);
  const [selectedMaharajId, setSelectedMaharajId] = useState('');
  const [maharajModalItem, setMaharajModalItem] = useState(null);
  const role = localStorage.getItem('userRole');

  const navigate = useNavigate();

  useEffect(() => {
    getIngredientList();
    getMaharajList();
  }, []);

  useEffect(() => {
    if (mealList.length > 0 && activeIndex != null) {
      console.log("active index:",activeIndex);
      getRMDetailForItem();
    }
  }, [mealList, activeIndex]);

  useEffect(() => {
    if (mealList.length > 0 && activeIndex != null) {
      console.log(activeIndex);
      console.log(mealList);
      const itemId =
        mealList.find((item, index) => index === activeIndex)?.menu_item_id ??
        null;
      const maharajId = mealList.find((item, index) => index === activeIndex)?.maharaj ?? null;
      const fetchDetail = async () => {
        setLoading(true)
        // Modified to use date range
        const dateRangeCondition = `menu_item_id='${itemId}' AND from_date = '${fromDate}' AND to_date = '${toDate}' AND session='${session[0].value}'`;
       
        const receipeMasteCondition = `menu_item_id='${itemId}' AND maharaj='${maharajId}'`;
        const batchQueries = [
          { key: 'process',    table: 'receipe_master_process', condition: receipeMasteCondition },
          { key: 'recipe',     table: 'receipe_master',          condition: receipeMasteCondition },
          { key: 'rm_receipe', table: 'rm_receipe',              condition: `${dateRangeCondition} GROUP BY ingredient_id order by id asc` },
        ];
        if (maharajId) batchQueries.push({ key: 'maharaj', table: 'maharaj_master', condition: `id='${maharajId}'` });
        const bd = (await axios.post(`${baseUrl}/comman/batch-list`, { queries: batchQueries })).data.data;

        if (maharajId && bd.maharaj?.length > 0) {
          setMaharajName(bd.maharaj[0]?.maharaj_name);
          setMaharajDetail(bd.maharaj[0]);
        }
        const recipeRows = bd.recipe ?? [];
        setRecipeStdRas(recipeRows?.[0]?.std_ras ?? null);
        const dbRows     = bd.rm_receipe ?? [];
        let ddArray = [];
        if(dbRows.length > 0 && ingredientList.length > 0){
          dbRows.filter((item) => item && item.ingredient_id !== 9090 && item.ingredient_id !== 9091 && item.ingredient_id !== 9092 && item.ingredient_id !== 9093).forEach((item, index) => {
            const data = ingredientList.find((v) => v.id == item.ingredient_id);
            const recipeRow = recipeRows.find((r) => r.ingredient_id == item.ingredient_id);
            const stdQty = recipeRow?.qty ?? recipeRows[index]?.qty ?? 0;
            const is_main = recipeRow?.is_main ? true : false;
            const dd = {ingredient_id : data.id, name : data.ingredient, unit: data.unit, stdQty: stdQty, required_qty : item.required_qty, baseQty: 0, store : data.store, db_id: item.id, is_main}
            ddArray.push(dd);
          });

          if(recipeRows.length > 0){
            recipeRows.forEach((item) => {
              const isPresent = ddArray.some((ddItem) => ddItem.ingredient_id === item.ingredient_id)
              if(!isPresent){
                const data = ingredientList.find((v) => v.id == item.ingredient_id);
                const stdQty = parseFloat(item.qty);
                const is_main = item.is_main ? true : false;
                const dd = {ingredient_id : data.id, name : data.ingredient, unit: data.unit, stdQty: stdQty, required_qty : stdQty, baseQty: stdQty, store : data.store, is_main}
                ddArray.push(dd);
              }
            })
          }

          const receipe_remarks = {ingredient_id : 9090, name : "receipe_remarks", unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""};
          const process_remarks = {ingredient_id : 9091, name : "process_remarks", unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""};
          const test_remarks = {ingredient_id : 9092, name : "test_remarks", unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""};
          const planning_remarks = {ingredient_id : 9093, name : "planning_remarks", unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""};
          const checkRemarks = dbRows.filter((item) => item && item.ingredient_id == 9090);
          if(checkRemarks.length > 0){ receipe_remarks.db_id = checkRemarks[0].id; receipe_remarks.remarks = checkRemarks[0].remarks; }
          const processRemarks = dbRows.filter((item) => item && item.ingredient_id == 9091);
          if(processRemarks.length > 0){ process_remarks.db_id = processRemarks[0].id; process_remarks.remarks = processRemarks[0].remarks; }
          const testRemarks = dbRows.filter((item) => item && item.ingredient_id == 9092);
          if(testRemarks.length > 0){ test_remarks.db_id = testRemarks[0].id; test_remarks.remarks = testRemarks[0].remarks; }
          const planningRemarks = dbRows.filter((item) => item && item.ingredient_id == 9093);
          if(planningRemarks.length > 0){ planning_remarks.db_id = planningRemarks[0].id; planning_remarks.remarks = planningRemarks[0].remarks; }
          ddArray.push(test_remarks, process_remarks, receipe_remarks, planning_remarks);

        }else if(recipeRows.length > 0 && ingredientList.length > 0){
          recipeRows.forEach((item) => {
            const data = ingredientList.find((v) => v.id == item.ingredient_id);
            const stdQty = parseFloat(item.qty);
            const is_main = item.is_main ? true : false;
            const dd = {ingredient_id : data.id, name : data.ingredient, unit: data.unit, stdQty: stdQty, required_qty : stdQty, baseQty: stdQty, store : data.store, is_main}
            ddArray.push(dd);
          })
          ddArray.push(
            {ingredient_id : 9092, name : "test_remarks",     unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""},
            {ingredient_id : 9091, name : "process_remarks",  unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""},
            {ingredient_id : 9090, name : "receipe_remarks",  unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""},
            {ingredient_id : 9093, name : "planning_remarks", unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""}
          );
        }else{
          ddArray = [];
          ddArray.push(
            {ingredient_id : 9092, name : "test_remarks",     unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""},
            {ingredient_id : 9091, name : "process_remarks",  unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""},
            {ingredient_id : 9090, name : "receipe_remarks",  unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""},
            {ingredient_id : 9093, name : "planning_remarks", unit: "", stdQty: "", required_qty : "", baseQty: 0, store : "", remarks: ""}
          );
        }
        setProcessStep(bd.process ?? []);
        setFormData(ddArray);
        setLoading(false)
      };
      fetchDetail();
    }
  }, [mealList, activeIndex, rmDetailForItem, ingredientList]);

  useEffect(() => {
    const savedIndex = localStorage.getItem('activeIndex');
    if (savedIndex !== null) {
      setActiveIndex(Number(savedIndex)); // Assuming you have a state setter for activeindex
    }
  
    // Optionally, clear the saved index if no longer needed
    localStorage.removeItem('activeIndex');
  }, []);

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
    localStorage.setItem('activeIndex', index === activeIndex ? null : index);
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const list = response.data.data.filter((item) => item.status == 1);
    setIngredientList(list);
  };

  const getMaharajList = async () => {
    try {
      const response = await axios.get(`${baseUrl}/maharaj/list`);
      setMaharajList(response.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  // Change Maharaj, as on Recipe Planning: the same modal, and the same reload afterwards so the
  // recipe, the process steps and the Maharaj Name shown above are all re-read for whoever the
  // item now belongs to -- the recipe is looked up by menu item AND maharaj.
  //
  // What differs is the reach. An item here is a whole date range against one session, so the
  // change is sent as that range and every day in it moves together; see mealMaharajUpdate.
  const handleOpenMaharajModal = (index) => {
    const meal = mealList[index];
    if (!meal || !meal.menu_item_id) {
      toast.error("Meal Master data not found for this item.");
      return;
    }
    setMaharajModalItem(meal);
    setSelectedMaharajId(meal.maharaj ? String(meal.maharaj) : '');
    setShowMaharajModal(true);
  };

  const handleSaveMaharaj = async () => {
    if (!maharajModalItem) return;
    try {
      setLoading(true);
      await axios.post(`${baseUrl}/meal_master/maharaj_update`, {
        from_date: fromDate,
        to_date: toDate,
        session: session[0]?.value,
        menu_item_id: maharajModalItem.menu_item_id,
        maharaj_id: selectedMaharajId || null,
      });
      toast.success('Maharaj updated successfully');
      setShowMaharajModal(false);
      // Recipe Planning reloads the page here. This screen does not reload on Save either --
      // it re-reads in place -- and a reload would depend on the filter putting the range and
      // the session back by itself, which it only does for an event it can find. So the item is
      // updated where it stands: the recipe, the process steps and the Maharaj Name are all read
      // off mealList[activeIndex].maharaj, so moving it re-runs that fetch for the new maharaj
      // and the panel stays open on the item being worked on.
      setMaharajName('');
      setMaharajDetail('');
      setMealList((prev) => prev.map((meal) => (
        meal.menu_item_id === maharajModalItem.menu_item_id
          ? { ...meal, maharaj: selectedMaharajId || null }
          : meal
      )));
    } catch (err) {
      console.log(err);
      toast.error('Failed to update Maharaj');
    } finally {
      setLoading(false);
    }
  };

  const getRMDetailForItem = async () => {
    setLoading(true)
    const item = mealList.find((item, index) => index == activeIndex);
    // Modified to use date range
    // const condition = `date BETWEEN '${fromDate}' AND '${toDate}' AND session = '${session[0].value}' AND menu_item_id = '${item.menu_item_id}'`;
    // const response = await axios.get(
    //   `${baseUrl}/comman/list?table=raw_material&condition=${condition}`
    // );
        const condition = `from_date = '${fromDate}' AND to_date = '${toDate}' AND session_id = '${session[0].value}' AND menu_item_id = '${item.menu_item_id}'`;
    const response = await axios.get(
      `${baseUrl}/comman/list?table=raw_material_summary&condition=${condition}`
    );
    console.log("response in raw material:",response.data.data);
    
    // Check for freeze across date range
    const frezzCondition = `menu_item_id='${item.menu_item_id}' AND date BETWEEN '${fromDate}' AND '${toDate}' AND session='${session[0].value}'`;
    const checkFrezz = await axios.get(`${baseUrl}/comman/list?table=production_receipe_planning&condition=${frezzCondition}`);
    const freez = checkFrezz.data.data.length > 0 ? true : false;
    setItemDisable((role == 0 || role == 1) ? false : freez);
    setRMDetailForItem(response.data.data);
    setLoading(false)
  };

  const handelFilterChange = async (fromDate, toDate, session) => {
    setFromDate(fromDate);
    setToDate(toDate);
    setSession(session);
    if (fromDate && toDate && session) {
      // Modified to use date range
      const condition = ` m.session='${session[0].value}' AND m.date BETWEEN '${fromDate}' AND '${toDate}'`;
      const response = await axios.get(
        `${baseUrl}/meal_master/session_count?condition=${condition}`
      );
      
      // Now we need to deduplicate the items, keeping only one entry per menu_item_id
      const uniqueItems = [];
      const uniqueItemIds = new Set();
      
      response.data.data.forEach(item => {
        if (!uniqueItemIds.has(item.menu_item_id)) {
          uniqueItemIds.add(item.menu_item_id);
          uniqueItems.push(item);
        }
      });
      
      setMealList(uniqueItems);
    }
  };
  
  // What this screen measures against, and the table that reads it.
  //
  // The day screen has one Estimated RM Qty; a range has one per session in it, and the sheet
  // plans the range as a whole -- so the Estimated RM Qty here is the range's total. The ras is
  // read the way Recipe Planning reads it: the recipe's own STD RAS when it has one, otherwise
  // the planned ras per 100 persons of the slot.
  const estRM = rmDetailForItem.reduce((total, current) => total + parseFloat(current?.planned_rm_qty || 0), 0);
  const stdRasValue = parseFloat(recipeStdRas);
  const rasValue = (!isNaN(stdRasValue) && stdRasValue !== 0)
    ? stdRasValue
    : parseFloat(rmDetailForItem?.[0]?.ras_qty_per_100_person);
  // Planned RM Qty and 100 Persons QTY are read back out of the stored Reqd Qty / 100 kg -- see
  // rebuildFromRequiredQty. Done here rather than as the rows are loaded because the figures it
  // needs arrive with the summary, which lands separately.
  const planningRows = rebuildFromRequiredQty(formData, { estRM, rasValue });
  const math = planningMath({ rows: planningRows, estRM, rasValue });

  // The index is into the SORTED row list the table renders, so an edit is matched back to
  // formData by ingredient_id rather than by position; the two orders are not the same.
  const handlePersonsQtyChange = (e, index) => {
    const target = math.ingredientRows[index];
    if (!target) return;
    setFormData((prev) => applyPersonsQtyEdit(math, rebuildFromRequiredQty(prev, { estRM, rasValue }), target, e.target.value));
  };

  const handleTablePlannedQtyChange = (e, index) => {
    const target = math.ingredientRows[index];
    if (!target) return;
    setFormData((prev) => applyPlannedQtyEdit(math, rebuildFromRequiredQty(prev, { estRM, rasValue }), target, e.target.value));
  };

  const handlePlannedQtyChange = (e, index) => {
    const { name, value } = e.target;

    if(name == 'receipe_remarks'){
      setFormData((prevFormData) => {
        const updatedFormData = prevFormData.map(item => 
          // Check if the item has the specified ingrid_id
          
          item.ingredient_id == 9090
              ? { ...item, remarks: value, name: name} // Update the item
              : item // Leave other items unchanged
      );
      return updatedFormData;
    });
    }else if(name == 'process_remarks'){
      setFormData((prevFormData) => {
        const updatedFormData = prevFormData.map(item => 
          // Check if the item has the specified ingrid_id
          
          item.ingredient_id == 9091
              ? { ...item, remarks: value, name: name} // Update the item
              : item // Leave other items unchanged
      );
      return updatedFormData;
    });
    }else if(name == 'test_remarks'){
      setFormData((prevFormData) => {
        const updatedFormData = prevFormData.map(item => 
          // Check if the item has the specified ingrid_id
          
          item.ingredient_id == 9092
              ? { ...item, remarks: value, name: name} // Update the item
              : item // Leave other items unchanged
      );
      return updatedFormData;
    });
    }else if(name == 'planning_remarks'){
      setFormData((prevFormData) => {
        const updatedFormData = prevFormData.map(item => 
          // Check if the item has the specified ingrid_id
          
          item.ingredient_id == 9093
              ? { ...item, remarks: value, name: name} // Update the item
              : item // Leave other items unchanged
      );
      return updatedFormData;
    });
    }else{
      setFormData((prevFormData) => {
        const updatedFormData = [...prevFormData];
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
        return updatedFormData;
    });
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true)
    const menu_item_id =
      mealList.find((item, i) => i == activeIndex)?.menu_item_id ?? 0;
    
    // Modified to use date range
    const combineData = {
      formData: formData.filter((item) => item && item.name !== "receipe_remarks" && item.name !== "process_remarks" && item.name !== "test_remarks" && item.name !== "planning_remarks"),
      fromDate: fromDate,
      toDate: toDate,
      session: session[0].value,
      menu_item_id: menu_item_id,
    };
    
    console.log("combine:",combineData);
    try {
      // Using the new batch endpoint for date range
      await axios.post(`${baseUrl}/raw_material/receipe`, combineData);
      if(formData.filter((item) => item && item.name == "planning_remarks")){
        // handleSaveFeedback(e);
      }
      toast.success("Data successfully!");
      // window.location.reload();
      await getRMDetailForItem();
    } catch (error) {
      toast.error("Failed to submit the form.");
      console.log(error);
    }
    setLoading(false)
  };

  // const handleSaveFeedback = async (e) => {
  //   e.preventDefault();
  //   const menu_item_id =
  //     mealList.find((item, i) => i == activeIndex)?.menu_item_id ?? 0;
  //   // Modified to use date range
  //   const combineData = {
  //     formData: formData.filter((item) => item && item.name == "receipe_remarks" || item.name == "process_remarks" || item.name == "test_remarks" || item.name == "planning_remarks"),
  //     fromDate: fromDate,
  //     toDate: toDate,
  //     session: session[0].value,
  //     menu_item_id: menu_item_id,
  //   };
  //   console.log(combineData);
  //   try {
  //     // Using the new batch endpoint for date range
  //     await axios.post(`${baseUrl}/raw_material/remarks`, combineData);
  //     toast.success("Feedback data successfully saved for all dates in range!");
  //     window.location.reload();
  //   } catch (error) {
  //     toast.error("Failed to submit the form feedback.");
  //     console.log(error);
  //   }
  // }
  
  const handleRefreshIngredient = async (e) => {
    e.preventDefault();
    setLoading(true)
    const menu_item_id = mealList.find((item, i) => i == activeIndex)?.menu_item_id ?? 0;
    const maharajId = mealList.find((item, index) => index === activeIndex)?.maharaj ?? null;
   
    const obj = {
      menu_item_id: menu_item_id, 
      maharaj_id: maharajId,
      fromDate: fromDate,
      toDate: toDate,
      session: session[0].value
    }
    const response = await axios.post(`${baseUrl}/receipe/rm_ingredient_refresh`, obj);
    
    const ingList = [];
    response.data.data.forEach((item) => {
        const data = ingredientList.find((v) => v.id == item.ingredient_id);
        const stdQty = parseFloat(item.qty);
        const dd = {ingredient_id: data.id, name: data.ingredient, unit: data.unit, stdQty: stdQty, required_qty: stdQty, baseQty: stdQty, store: data.store}
        ingList.push(dd);
    })
    
    // Modified to use date range
    const combineData = {
      formData: ingList,
      fromDate: fromDate,
      toDate: toDate,
      session: session,
      menu_item_id: menu_item_id,
    };
    
    console.log(combineData);
    try {
      // Using the new batch endpoint for date range
      await axios.post(`${baseUrl}/raw_material/receipe`, combineData);
      if(formData.filter((item) => item && item.name == "planning_remarks")){
        // handleSaveFeedback(e);
      }
      toast.success("Data successfully refreshed for all dates in range!");
      window.location.reload();
    } catch (error) {
      toast.error("Failed to refresh ingredients.");
      console.log(error);
    }
    setLoading(false)
  }
  
  const handleAddIngredient = async (ingredient, plannedQty) => {
    if (!ingredient?.value) return;
    const menu_item_id = mealList.find((item, i) => i == activeIndex)?.menu_item_id ?? 0;
    // The ingredient is in no master recipe, so it comes with no qty per 100 kgs -- the figure
    // "100 Persons STD QTY" is read from. The Planned RM Qty typed into the modal is the standard
    // the planner has just set for it, so it becomes the row's own, per 100 kgs of the range's
    // Estimated RM Qty: the same conversion a Planned RM Qty edit makes on every other row.
    const planned = parseFloat(plannedQty) || 0;
    const perHundredKg = estRM > 0 ? parseFloat(((planned * 100) / estRM).toFixed(2)) : 0;
    const ob = {
      ingredient_id: ingredient.value,
      name: ingredient.name,
      unit: ingredient.data.unit,
      stdQty: perHundredKg,
      required_qty: perHundredKg,
      planned_qty: planned,
      baseQty: 0,
      store: ingredient.data.store,
    };
    setLoading(true);
    try {
      await axios.post(`${baseUrl}/raw_material/receipe`, {
        formData: [ob],
        fromDate: fromDate,
        toDate: toDate,
        session: session[0].value,
        menu_item_id: menu_item_id,
      });
      toast.success("Ingredient added!");
      // The rows are read again rather than the page being reloaded, so the recipe that was open
      // stays open -- setting the summary is what the detail fetch listens to.
      await getRMDetailForItem();
    } catch (error) {
      toast.error("Failed to add the ingredient.");
      console.log(error);
    }
    setLoading(false);
  } 

  const handleProcessedit = (e) => {
    e.preventDefault();
    const menu_item_id =
          mealList.find((item, i) => i == activeIndex)?.menu_item_id ?? 0;
    const obj = [{
      id: menu_item_id,
      maharaj: maharajDetail
    }];
     
    navigate(`/receipe/edit/${btoa(menu_item_id)}`, { state: obj });
  }

  const handleRecipeExport = (e, index) => {
    // Export functionality - to be implemented
    e.preventDefault();
    // ... export logic
  }
  console.log("meallist:",mealList);
  console.log("active index:",activeIndex);
  return (
    <div className="">
      {loading && <Loader/>}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Raw Material Recipe Planning (Event)
        </h1>
        {/* <div className="flex items-center gap-4">
          <a
            href="/raw_material_recipe_day/list"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
          >
            Day Wise
          </a>
        </div> */}
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <EventDateSessionFilter handleFilterChange={handelFilterChange} />
        <div>
          {mealList.map((item, index) => (
            <div key={index} className="border-b mt-4">
              <div
                className="flex justify-between items-center p-4 cursor-pointer accordion-title bg-orange-400 border rounded"
                onClick={() => handleClick(index)}
              >
                <div className="flex flex-col">
                  <span className="font-bold"><ItemNameStacked item={item} /></span>
                  <span className="text-sm">Sessions: {item.sessionCount}</span>
                </div>
                {index === activeIndex ? (
                  <ChevronUpIcon className="w-6 h-6" />
                ) : (
                  <ChevronDownIcon className="w-6 h-6" />
                )}
              </div>
              {index === activeIndex && (
                <div className="space-y-2 p-4 bg-white">
                  <div className="flex justify-between">
                    <div className="lg:w-96">
                      <div className="flex flex-wrap justify-between">
                        <div className="sm:text-sm lg:text-base font-bold">
                          Total Planned Count (Persons):
                        </div>
                        {/* <div>{item.total_planned_count || 0}</div> */}
                        {rmDetailForItem?.[0]?.total_planned_count ?? 0}
                      </div>
                      <div className="flex flex-wrap justify-between">
                        <div className="sm:text-sm lg:text-base font-bold">
                          Sessions in Date Range:
                        </div>
                        <div>{item.sessionCount || 1}</div>
                      </div>
                      <div className="flex flex-wrap justify-between">
                        <div className="sm:text-sm lg:text-base font-bold">
                          Planned Ras Qty/100 (Persons):
                        </div>
                        <div>{rmDetailForItem?.[0]?.ras_qty_per_100_person ?? 0}</div>
                      </div>
                      <div className="flex flex-wrap justify-between">
                        <div className="sm:text-sm lg:text-base font-bold">
                          Total Planned RM Qty (kgs):
                        </div>
                        {/* Calculate total based on all sessions */}
                        <div>
                          {rmDetailForItem.reduce((total, current) => total + parseFloat(current?.planned_rm_qty || 0), 0).toFixed(2)}
                        </div>
                      </div>
                      <div className="flex flex-wrap justify-between">
                        <div className="sm:text-sm lg:text-base font-bold">
                        Maharaj Name:
                        </div>
                        <div>{maharajName ?? '-'}</div>
                      </div>
                      <div className="flex justify-between">
                        <div className="sm:text-sm lg:text-base font-bold">
                        Planning Remarks:
                        </div>
                        <div>
                        <textarea
                            name="planning_remarks"
                            id="remarks"
                            placeholder='Remarks'
                            value={formData.find(item => item.name === 'planning_remarks')?.remarks || ''}
                            onChange={(e) => handlePlannedQtyChange(e, 9093)}
                            className="block w-full rounded-md border py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                            rows="4" // Adjust the number of rows as needed
                          />
                        </div>
                      </div>
                    </div>
                    <div className="justify-end">
                      {/* On the button rather than on a Link around it: a disabled button inside
                          an anchor leaves the anchor clickable around its edges. */}
                      <button
                        onClick={() => window.open("/reports/receipe_feedback", "_blank", "noopener,noreferrer")}
                        disabled={REPORT_BUTTONS_DISABLED}
                        className={`px-4 py-2 text-white rounded-md placeholder:text-sm mr-2 float-right ${REPORT_BUTTONS_DISABLED ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500'}`}>
                        Recipe Feedback Report
                      </button>
                    </div>
                    <div className="justify-end">
                      <button
                        className="px-4 py-2 bg-blue-500 text-white rounded-md placeholder:text-sm mr-2 float-right"
                        onClick={() => handleOpenMaharajModal(index)}
                      >
                        Change Maharaj
                      </button>
                    </div>
                    <div className="justify-end">
                      <Link to="#"
                        onClick={() => window.open("/receipe/list", "_blank", "noopener,noreferrer")}>
                        <button className="px-4 py-2 bg-green-500 text-white rounded-md placeholder:text-sm mr-2 float-right">
                          Add New Recipe 
                        </button>
                      </Link>
                    </div>
                  </div>
                  <ModalContent showModal={showModal} setShowModal={setShowModal} ingredientList={ingredientList} handleAddIngredient={handleAddIngredient} ingredientDetail={formData} showPlannedQty />
                  {showMaharajModal && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
                        <h3 className="text-lg font-bold mb-4">Change Maharaj</h3>
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Menuitem</label>
                          <div className="px-3 py-2 bg-gray-100 border border-gray-300 rounded-md text-gray-900">
                            {maharajModalItem ? `${maharajModalItem.item_name}${maharajModalItem.eng_name ? ` (${maharajModalItem.eng_name})` : ''}` : '-'}
                          </div>
                        </div>
                        <div className="mb-6">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Maharaj Name</label>
                          <select
                            value={selectedMaharajId}
                            onChange={(e) => setSelectedMaharajId(e.target.value)}
                            className="block w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="">-- Select Maharaj --</option>
                            {maharajList.map((m) => (
                              <option key={m.id} value={m.id}>{m.maharaj_name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="flex justify-end gap-2">
                          <button
                            type="button"
                            onClick={() => setShowMaharajModal(false)}
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={handleSaveMaharaj}
                            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="flex overflow-x-auto">
                    <div className="gap-5 mb-4 mt-10 ms-2 flex-shrink-0 ">
                      {/* The same table Recipe Planning shows, from the same arithmetic: main
                          items and other items in their own sections, each with its own totals,
                          and the two editable columns tied to each other. The Main Item tick
                          reads Recipe Master here -- rm_receipe has no is_main column of its own
                          to keep an event's own answer in. */}
                      {formData.length > 0 && (
                        <RecipePlanningTable
                          math={math}
                          disabled={itemDisable}
                          onPersonsQtyChange={handlePersonsQtyChange}
                          onPlannedQtyChange={handleTablePlannedQtyChange}
                          mainItemEditable={false}
                        />
                      )}
                      <div className="border p-2">
                        {!itemDisable && <>
                          <button
                            disabled={itemDisable}
                            onClick={(e) => { handleSave(e)}}
                            className="px-4 py-2 bg-green-500 text-white rounded-md placeholder:text-sm mr-2 float-right"
                          >
                            Save 
                          </button>
                          <button
                            disabled={itemDisable}
                            onClick={() => setShowModal(true)}
                            className="px-4 py-2 bg-green-500 text-white rounded-md placeholder:text-sm mr-2 float-right"
                          >
                            Add Ingredient
                          </button>
                          <button 
                            onClick={(e) => {
                              handleRefreshIngredient(e);
                            }}
                            className="px-4 py-2 bg-green-500 text-white rounded-md placeholder:text-sm mr-2 float-right"
                          >
                            Refresh 
                          </button>
                        </>}
                        <button
                          onClick={(e) => {
                            handleRecipeExport(e, index);
                          }}
                          className="px-4 py-2 bg-blue-500 text-white rounded-md placeholder:text-sm mr-2"
                        >
                          Export
                        </button>
                      </div>
                    </div>
                    {/* Process Steps and Feedback & Remarks, hidden for now -- see
                        SHOW_PROCESS_AND_REMARKS. Left standing rather than taken out: the remarks
                        rows are still loaded and still saved, so what is already written survives
                        being out of sight, and turning the panels back on shows it again. */}
                    {SHOW_PROCESS_AND_REMARKS && (
                    <div className="gap-5 px-10 mb-4 mt-10 flex-shrink-0">
                      {/* Process Steps Section */}
                      <div className="border p-2 mb-4">
                        <h3 className="font-bold mb-2">Process Steps</h3>
                        {processStep.length > 0 ? (
                          <div>
                            {processStep.map((step, idx) => (
                              <div key={idx} className="mb-2">
                                <span className="font-semibold">Step {idx + 1}:</span> {step.process_details}
                              </div>
                            ))}
                            <div className="mt-4">
                              <button
                                onClick={handleProcessedit}
                                className="px-4 py-2 bg-blue-500 text-white rounded-md placeholder:text-sm mr-2"
                              >
                                Edit Process
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <p>No process steps available.</p>
                            <button
                              onClick={handleProcessedit}
                              className="px-4 py-2 bg-blue-500 text-white rounded-md placeholder:text-sm mt-2"
                            >
                              Add Process
                            </button>
                          </div>
                        )}
                      </div>
                      
                      {/* Feedback/Remarks Section */}
                      <div className="border p-2">
                        <h3 className="font-bold mb-2">Feedback & Remarks</h3>
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Recipe Remarks</label>
                          <textarea
                            name="receipe_remarks"
                            placeholder="Recipe Remarks"
                            value={formData.find(item => item.name === 'receipe_remarks')?.remarks || ''}
                            onChange={(e) => handlePlannedQtyChange(e, null)}
                            className="block w-full rounded-md border py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                            rows="3"
                          />
                        </div>
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Process Remarks</label>
                          <textarea
                            name="process_remarks"
                            placeholder="Process Remarks"
                            value={formData.find(item => item.name === 'process_remarks')?.remarks || ''}
                            onChange={(e) => handlePlannedQtyChange(e, null)}
                            className="block w-full rounded-md border py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                            rows="3"
                          />
                        </div>
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Test Remarks</label>
                          <textarea
                            name="test_remarks"
                            placeholder="Test Remarks"
                            value={formData.find(item => item.name === 'test_remarks')?.remarks || ''}
                            onChange={(e) => handlePlannedQtyChange(e, null)}
                            className="block w-full rounded-md border py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                            rows="3"
                          />
                        </div>
                
                      </div>
                    </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RawMaterialReceipePlanning;